import { Button } from "@meiden-connect/ui";
import { useCanvasStore } from "../store/canvas-store";
import { stepZoomIn, stepZoomOut, zoomAt } from "../../../lib/canvas-coordinates";

// ミニマップ下に配置する - / + ズームボタン。
// 画面中央を中心にズームを段階的に変更する。
export function ZoomButtons(): JSX.Element {
  const view = useCanvasStore((s) => s.view);
  const setView = useCanvasStore((s) => s.setView);

  const screenCenter = { x: window.innerWidth / 2, y: window.innerHeight / 2 };

  const onZoomOut = (): void => {
    setView(zoomAt(view, screenCenter, stepZoomOut(view.zoom)));
  };
  const onZoomIn = (): void => {
    setView(zoomAt(view, screenCenter, stepZoomIn(view.zoom)));
  };

  return (
    <div className="canvas-zoom-buttons">
      <Button type="button" aria-label="縮小" onClick={onZoomOut} variant="action">
        −
      </Button>
      <span>{Math.round(view.zoom * 100)}%</span>
      <Button type="button" aria-label="拡大" onClick={onZoomIn} variant="action">
        ＋
      </Button>
    </div>
  );
}
